<template>
  <section>
    <!-- Message (success) -->
    <message-view :show="showMessage">
      <!-- Title -->
      <template slot="title">
        {{ $t('message_3') }}
      </template>

      <!-- Message -->
      <template slot="message">
        {{ $t('message_4') }}
      </template>

      <!-- Action -->
      <template slot="action">
        <button-view
          type="submit"
          variant="center special"
          @click.native="closeMessage()"
        >
          {{ $t('message_6') }}
        </button-view>
      </template>
    </message-view>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ContactResponse',

  components: {
    ButtonView: () => import('@/components/button/button-view'),
    MessageView: () => import('@/components/message/message-view')
  },

  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      contactResponse: 'contact/getContactResponse'
    }),
    showMessage() {
      if (this.contactResponse) {
        return true;
      }
      return false;
    }
  },
  methods: {
    closeMessage() {
      this.$router.push({ name: 'contact' });
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/contact/contact-form-view.scss"></style>



// WEBPACK FOOTER //
// contact-response.vue